import { isAfter, isBefore } from "date-fns";

const useV6TimeEventColumns = (events) => {
  const columns = [{ ranges: [] }];
  const sheetColumnMap = {};

  if (Array.isArray(events) && events?.length) {
    events.forEach(event => {
      if (!event.extendedProps?.heightEnd && !event.extendedProps?.heightStart) return;
      const hStart = event.extendedProps?.heightStart;
      const hEnd = event.extendedProps?.heightEnd;

      const column = columns.findIndex(col =>
        !col.ranges?.some(range => isBefore(hStart, range.end) && isAfter(hEnd, range.start))
      );

      const targetColumn = column === -1 ? columns.length : column;
      if (!columns[targetColumn]) columns.push({ ranges: [] });
      columns[targetColumn].ranges.push({ start: hStart, end: hEnd });
      sheetColumnMap[event.extendedProps?.sheet?._id] = targetColumn;
    });
  }

  return { columns, sheetColumnMap };
};

export default useV6TimeEventColumns;